import callBackend from '../shared/methods/callBackend/callBackend';

const deleteOpeningHours = async (id) => callBackend({
  url: `${process.env.REACT_APP_API_URL}/openinghours/${id}`,
  method: 'DELETE',
});

export default deleteOpeningHours;
